var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruckColourful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M7.5 15a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm9 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4350F7",
    d: "M21.5 15H21v-3.378c0-.398-.16-.779-.44-1.06l-3.122-3.121A1.5 1.5 0 0016.378 7H15V5.5A1.5 1.5 0 0013.5 4h-10A1.5 1.5 0 002 5.5v10A1.5 1.5 0 003.5 17h.567c.245-1.69 1.676-3 3.433-3s3.204 1.308 3.45 3h2.1c.246-1.692 1.691-3 3.45-3 1.759 0 3.188 1.31 3.433 3H21.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm-2-3H15V8.5h1.378l3.122 3.122V12z"
  }))));
}

export default SvgTruckColourful;